import React from "react"

import { PrimaryText } from "@front-shared/elements/primaryText.element.tsx"

import {
    PolicySidebarTab,
    PolicySidebarViewMode,
} from "../../../config/policies.config"
import { useAppSelector } from "../../../store/selectors/app.selector"
import { policiesSelector } from "../../../store/selectors/policies.selector"

import closeIcon from "@front-shared/assets/images/icons/close-dark.svg"
import collapseIcon from "@front-shared/assets/images/icons/comments-collapse.svg"
import expandIcon from "@front-shared/assets/images/icons/comments-expand.svg"

export const PolicySidebarHeaderComponent: React.FunctionComponent<
    IPolicySidebarHeaderComponentProps
> = props => {
    const { selectedItemHistoryPagination, selectedItemComments } =
        useAppSelector(policiesSelector)

    return (
        <div
            className={`
                sticky left-0 top-0 w-full
                flex bg-brand-offWhite
                border-b border-solid border-brand-warmLight
                ${props.viewMode === PolicySidebarViewMode.CLOSED ? "h-full md:h-auto" : "items-center"}
            `}
        >
            <div
                className={`
                    relative cursor-pointer
                    p-[11px] flex justify-center
                    md:hidden
                    ${
                        // When the comments are closed, the entire height of the visible area which remains should be clickable
                        props.viewMode === PolicySidebarViewMode.CLOSED
                            ? "h-full"
                            : "border-r border-solid border-brand-warmLight items-center"
                    }
                `}
                onClick={() => {
                    if (props.viewMode === PolicySidebarViewMode.DEFAULT) {
                        props.setViewMode(PolicySidebarViewMode.EXPANDED)
                    } else {
                        props.setViewMode(PolicySidebarViewMode.DEFAULT)
                    }
                }}
            >
                <img
                    src={
                        props.viewMode === PolicySidebarViewMode.EXPANDED
                            ? collapseIcon
                            : expandIcon
                    }
                    alt="Comments"
                    className="w-[10px] h-[10px]"
                />
            </div>

            <button
                type="button"
                className={`
                    flex-1 h-full
                    hover:underline
                    ${props.selectedTab === PolicySidebarTab.HISTORY ? "opacity-100 bg-brand-white" : "opacity-75"}
                    ${props.viewMode === PolicySidebarViewMode.CLOSED ? "hidden md:block" : ""}
                `}
                onClick={() => {
                    props.setSelectedTab(PolicySidebarTab.HISTORY)
                }}
            >
                <PrimaryText typography="h6">
                    Checks
                    {selectedItemHistoryPagination.total > 0
                        ? ` (${selectedItemHistoryPagination.total})`
                        : ""}
                </PrimaryText>
            </button>

            {!props.hideCommentsTab && (
                <div className="h-full my-auto border-r border-solid border-brand-warmLight" />
            )}

            {!props.hideCommentsTab && (
                <button
                    type="button"
                    className={`
                    flex-1 h-full
                    hover:underline
                    ${props.selectedTab === PolicySidebarTab.COMMENTS ? "opacity-100 bg-brand-white" : "opacity-75"}
                    ${props.viewMode === PolicySidebarViewMode.CLOSED ? "hidden md:block" : ""}
                `}
                    onClick={() => {
                        props.setSelectedTab(PolicySidebarTab.COMMENTS)
                    }}
                >
                    <PrimaryText typography="h6">
                        Comments
                        {selectedItemComments.length > 0
                            ? ` (${selectedItemComments.length})`
                            : ""}
                    </PrimaryText>
                </button>
            )}

            <div
                className={`
                    relative cursor-pointer border-l border-solid border-brand-warmLight
                    p-[11px] flex items-center justify-center
                    md:hidden
                    ${props.viewMode === PolicySidebarViewMode.CLOSED ? "hidden" : ""}
                `}
                onClick={() => {
                    props.setViewMode(PolicySidebarViewMode.CLOSED)
                }}
            >
                <img
                    src={closeIcon}
                    alt="Close"
                    className="w-[10px] h-[10px]"
                />
            </div>
        </div>
    )
}

interface IPolicySidebarHeaderComponentProps {
    viewMode: PolicySidebarViewMode
    setViewMode: (viewMode: PolicySidebarViewMode) => void
    selectedTab: PolicySidebarTab
    setSelectedTab: (tab: PolicySidebarTab) => void
    hideCommentsTab: boolean
}
